<template lang="pug">
  .social-share__body
    slot

    a.social-share__item(
      v-for="social in socials"
      :key="social.icon"
      :title="social.title"
      @click.prevent="onSocialClick(social)"
    )
      img(:src="require(`~/assets/img/icons/${social.icon}.svg`)" width="20" alt="icon")
</template>

<script>
export default {
  name: 'SocialShareIcons',

  computed: {
    socials () {
      return [
        {
          icon: 'telegram',
          url: 'http://telegram.me/share/url?url=',
          title: `${this.$t('shareOn')} Telegram`
        },
        // {
        //   icon: 'vk',
        //   url: 'http://vk.com/share.php?url=',
        //   title: `${this.$t('shareOn')} VK`,
        // },
        {
          icon: 'facebook',
          url: 'https://www.facebook.com/sharer/sharer.php?u=',
          title: `${this.$t('shareOn')} Facebook`
        },
        {
          icon: 'twitter',
          url: 'https://twitter.com/intent/tweet?url=',
          title: `${this.$t('shareOn')} Twitter`
        }
      ]
    }
  },

  methods: {
    onSocialClick (social) {
      const screenSize = { height: screen.height, width: screen.width }
      const windowSize = {
        height: screenSize.height / 2,
        width: screenSize.width / 2
      }

      const top = screenSize.height / 2 - windowSize.height / 2
      const left = screenSize.width / 2 - windowSize.width / 2

      return window.open(
        social.url + this.$config.WWW_HOST + this.$route.path,
        'blank',
        `
         top=${top},
         left=${left},
         width=${windowSize.width},
         height=${windowSize.height},
         toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,
        `
      )
    }
  }
}
</script>

<style lang="scss">
.social-share {
  &__body {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    height: 100%;

    .--down & {
      flex-direction: column;
    }
  }

  &__item {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    cursor: pointer;

    svg path {
      transition: fill 0.2s $easing;
      fill: $fc-grey-2;
    }

    &:hover svg path {
      fill: $blue-grey05;
    }

    &:active svg path {
      fill: $white;
    }
  }

  @media (max-width: $breakpointHeaderMobile) {
    &__item {
      padding: 10px;
      min-height: 40px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
